export const ACCESS_TYPE = 'ws'; // ws or sse 标志链接方式
export const APP_KEY = 'tuZdOfKhLuAftGWKcyVhfMzuoxlBMGCjzjcpxVPgJexobqYMEsTqNRlMSNdtjJMzmPohPscQeaoZoKdDbbvLFCPtAqaEZwIJiBBmvFWwbvhUJSNbQHZRdufvLIpsGLCb'; // compliance-assistant 的 appkey（使用后端默认的，余额充足）
export const GRAPH_APP_KEY = 'DcylIdlLdRARMqtTrVyPrxRwKnPDMErLOWnlDXacDasFDnWLEHUgezBPIETNIxVWAHQoLtGhkjMcmzYmuyanKXLGGdOaQskKMByXGrMCcWshWmEfgAUnPvDkloAqlmqa'; // graph-assistant 的 appkey
export const ATLAS_APP_KEY = 'icvGBDZWaxnilyrWJswjoNmLzzBzhYVOrjPiXzQEuiSSKtTlnvwYbivUEIQCIrOehXXSPjGrYiUOiaUWBemguYCXARvuNtLnOvOgiVutyGwAMErPhCGnlRgygdbUsNdT'; // atlas-assistant 的 appkey

// API配置 - 支持本地开发和部署环境
// 开发环境：通过 webpack proxy 代理到本地或第三方服务
// 生产环境：使用环境变量配置的完整域名
export const API_BASE_URL = process.env.VUE_APP_API_BASE_URL || '/api';
export const TENCENT_API_BASE_URL = process.env.VUE_APP_TENCENT_API_BASE_URL || '';



// WEBPACK FOOTER //
// ./src/constants/static.js